import type { ReactNode } from 'react';
import { cn } from '@shared/lib/cn';
import type { MediaLink } from '../types';

export function MediaDownloadLink({
  link,
  children,
  className,
  download = true,
}: {
  link: MediaLink | null | undefined;
  children: ReactNode;
  className?: string;
  download?: boolean;
}) {
  if (!link?.url) {
    return <span className={cn('text-muted-foreground', className)}>{children}</span>;
  }
  return (
    <a
      href={link.url}
      target="_blank"
      rel="noreferrer"
      download={download ? '' : undefined}
      className={cn('text-primary hover:underline', className)}
    >
      {children}
    </a>
  );
}
